import React from "react";
import RoomsView from "./RoomsView"

class Rooms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    //this.handleClose = this.handleClose.bind(this);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  render() {
    return (
      //<RoomsView hotel={this.props.hotel} sortHotelPhotos={this.props.sortHotelPhotos} removeHotelPhoto={this.props.removeHotelPhoto} editHotelPhoto={this.props.editHotelPhoto}/>
      <RoomsView removeRoomPhoto={this.props.removeRoomPhoto} {...this.props} handleEdit={this.handleEdit} />
    )
  }
}

export default Rooms


// WEBPACK FOOTER //
// src/routes/hotels/components/Rooms.js